<template>
  <div class="g-recharge-list">
    <div class="recharge-list-top">
      <div class="top-l">
        <el-date-picker
        v-model="start_date"
        type="date"
        placeholder="年/月/日">
        </el-date-picker>
        <span class="text">至</span>
        <el-date-picker
        v-model="end_date"
        :picker-options="pickerOptions1"
        type="date"
        placeholder="年/月/日">
        </el-date-picker>
        <el-button class="top-l-search" @click="searchClick()">查询</el-button>
        <div style="clear:both;"></div>
      </div>
      <div style="clear:both;"></div>
    </div>
    <div class="recharge-list-bottom">
      <div class="recharge-list-table">
        <el-table
        :data="yemiandata"
        :header-cell-style="{background:'#f3f3f3',color:'#323232',height:'50px'}"
        border
        style="width: 100%">
            <el-table-column
            prop="nickname"
            label="客户名称"
            width="150">
            </el-table-column>
            <el-table-column
            prop="username"
            label="充值账户"
            width="150">
            </el-table-column>
            <el-table-column
            prop="type"
            label="充值方式"
            width="130">
            </el-table-column>
            <el-table-column
            prop="order_sn"
            label="订单号"
            width="">
            </el-table-column>
            <el-table-column
            prop="operate_user"
            label="操作用户"
            width="">
            </el-table-column>
            <el-table-column
            prop="fee"
            label="充值金额"
            width="">
            </el-table-column>
            <!-- <el-table-column
            prop="timestamp"
            label="创建时间"
            width="160">
              <template slot-scope="scope">{{ scope.row.timestamp | defaultValFilter }}</template>
            </el-table-column> -->
            <el-table-column
            prop="pay_time"
            label="充值时间"
            width="160">
              <template slot-scope="scope">{{ scope.row.pay_time | defaultValFilter }}</template>
            </el-table-column>
            <!-- <el-table-column
            prop="operate_user"
            label="平台充值管理员"
            width="130">
            </el-table-column> -->
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          @size-change="handleSizeChange"
          @current-change="currentChange"
          :total="totalNum"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { parseDateFilter } from "@/filters";
export default {
  data() {
    return {
      tableData: [],
      // 页面需要展现的数据
      yemiandata: [],
      // 页面展现条数
      datanum: 10,
      // 开始页数
      startnum: 0,
      // 结束页数
      endnum: 1,
      // 一共多少页
      totalNum: 0,
      value: "",
      options:[],
      start_date:"",
      end_date:"",
      pickerOptions1: {
        disabledDate: (time) => {
          return time.getTime() < this.start_date || time.getTime() > Date.now();
        }
      },
    };
  },
  mounted() {
    this.$nextTick(function() {
      this.getDataList();
    });
  },
  methods: {
    handleSizeChange(data){
      // debugger
    },
    currentChange(data){
      this.endnum = data;
      this.startnum = data-1;
      // this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
      if(this.totalNum > 10){
        this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
      } else {
        this.yemiandata=this.tableData;
      }
    },
    getDataList(start_date,end_date){
      if(start_date == undefined){
        start_date = "";
      }
      if(end_date == undefined){
        end_date = "";
      }
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"getCustomerRechargeLogs",
        start_date:start_date ? parseDateFilter(start_date, 'yyyy-MM-dd') : '',
        end_date:end_date ? parseDateFilter(end_date, 'yyyy-MM-dd') : '',
      };
      this.$api({
        method: "post",
        url: "/api.php/Customer2/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.tableData = su.data.list;
            this.totalNum = this.tableData.length;
            if(this.totalNum > 10){
              // debugger
              this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
            } else {
              this.yemiandata=this.tableData;
            }
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900)  {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {});
    },
    searchClick(){
      this.startnum = 0;
      this.endnum = 1;
      this.totalNum = 0;
      this.getDataList(this.start_date,this.end_date);
    },
  }
};
</script>

<style scoped lang="scss">
.g-recharge-list {
  padding:20px 0;
  .recharge-list-top {
    .top-l {
      float: left;
      margin-left: 1%;
      .el-select {
        width: 20%;
        float: left;
        margin-right: 10px;
      }
      .el-input {
        width: 30%;
        float: left;
        margin-right: 10px;
      }
      .top-l-search {
        background-color: #0071bd;
        border: none;
        color: #fefffd;
        float: left;
      }
      .text {
        float: left;
        // margin: 4px;
        margin-top: 8px;
        margin-right: 10px;
      }
    }
  }
  .recharge-list-bottom {
    .recharge-list-table {
        width: 98%;
        margin-left: 1%;
        margin-top: 26px;
        margin-bottom: 10px;
        .table-btn {
            width: 54px;
            height: 30px;
            padding: 0;
            background-color: #006fbe;
            border:none;
            color: #fefffd;
            margin-left: 5px;
        }
        .table-vehicle {
            background-color: #00b270;
        }
        .table-dis {
            background-color: #eb0000;
        }
        .table-recharge {
            background-color: #ec6900;
        }
    }
    .pagination {
      display: flex;
      justify-content: flex-end;
      padding-bottom: 24px;
      margin-top: 20px;
      margin-right: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/membershipManagement/gRechargeRecord.vue